import { ProductModel } from '@/types/model/Product'

export const mapFormToProductBody = (data: ProductModel.ProductFormData) => ({
  name: data.name,
  slug: data.slug,
  summary: data.summary,
  description: data.description,
  tags: data.tags,
  delivery_return_policy: data.deliveryReturnPolicy,
  category_id: data.category,
  brand_id: data.brand,
  status: data.status,
  discount_type: data.discountType,
  discount: data.discount,
  attribute_ids: data.attributes,
  meta_title: data.metaTitle,
  meta_description: data.metaDescription,
  meta_keywords: data.metaKeywords,
  thumbnail_id: data.thumbnailId,
  price_type: data.priceType,
  sold_by_unit: data.soldByUnit,
})

export const mapFormToVariationBody = (
  v: ProductModel.ProductVariationFormData,
  productId: string
) => ({
  product_id: productId,
  name: v.name,
  slug: v.slug,
  description: v.description,
  summary: v.summary,
  delivery_return_policy: v.delivery_return_policy,
  purchase_cost: v.purchase_cost,
  regular_price: v.regular_price,
  attribute_value_ids: v.attribute_value_ids || [],
  image_ids: v.images?.map((img: any) => img.id || img._id) || [],
  sku: v.sku,
  initial_stock_quantity: v.initial_stock_quantity,
  status: v.status || 'active',
  search_keywords: v.search_keywords,
  barcodes: v.barcodes,
})
